var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C11.0708 22.8048 10.141 22.6539 9.27672 22.3082C8.41248 21.9625 7.63511 21.4305 7.00001 20.75C4.72001 18.17 5.20001 14.09 5.23001 13.92V6C5.25001 4.36 6.00001 1.25 9.00001 1.25C12 1.25 12.75 4.36 12.75 6V14C12.75 14.1989 12.671 14.3897 12.5303 14.5303C12.3897 14.671 12.1989 14.75 12 14.75C11.8011 14.75 11.6103 14.671 11.4697 14.5303C11.329 14.3897 11.25 14.1989 11.25 14V6C11.25 5.87 11.25 2.75 9.00001 2.75C6.75001 2.75 6.75001 5.87 6.75001 6V14C6.75001 14.13 6.33001 17.69 8.16001 19.75C8.65101 20.2662 9.24949 20.6681 9.91308 20.9273C10.5767 21.1866 11.2891 21.2967 12 21.25C12.7109 21.2967 13.4233 21.1866 14.0869 20.9273C14.7505 20.6681 15.349 20.2662 15.84 19.75C17.67 17.69 17.26 14.13 17.26 14.09V2C17.26 1.80109 17.339 1.61032 17.4797 1.46967C17.6203 1.32902 17.8111 1.25 18.01 1.25C18.2089 1.25 18.3997 1.32902 18.5403 1.46967C18.681 1.61032 18.76 1.80109 18.76 2V14C18.76 14.08 19.26 18.16 16.98 20.74C16.348 21.4196 15.5743 21.9519 14.7137 22.2993C13.8531 22.6466 12.9267 22.8005 12 22.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachment);
export default __webpack_public_path__ + "static/media/icon_attachment.3ca9583580f61a95cdf6dd6e7cb86a6d.svg";
export { ForwardRef as ReactComponent };